/**
 * YES!PIECE — Galerie-Filter v15
 * - Varianten-Filter mit alt-Text für Videos
 * - 2+1+2 Layout via flex width
 * - PhotoSwipe Click-Handler
 * - Video Lightbox
 */

(function () {

  window.ypVisibleItems = [];

  function normalizeVariantName(name) {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  function getActiveVariantName() {
    const checked = document.querySelector('input[type="radio"]:checked');
    return checked ? normalizeVariantName(checked.value) : null;
  }

  function getAllVariantNames() {
    const radios = document.querySelectorAll('input[type="radio"]');
    const names = [];
    radios.forEach(r => names.push(normalizeVariantName(r.value)));
    return [...new Set(names)];
  }

  function getItems() {
    return document.querySelectorAll('.product__media-list .product__media-item');
  }

  function applyGridPattern(visibleItems) {
    const gap = '4px';
    visibleItems.forEach((item, i) => {
      item.style.width = '';
      item.style.flex = '';
      item.style.maxWidth = '';

      if (i === 2 || i === 5) {
        item.style.width = 'calc(100% - 0px)';
        item.style.flex = '0 0 100%';
        item.style.maxWidth = '100%';
      } else {
        item.style.width = 'calc(50% - 2px)';
        item.style.flex = '0 0 calc(50% - 2px)';
        item.style.maxWidth = 'calc(50% - 2px)';
      }
    });

    const list = document.querySelector('.product__media-list');
    if (list) {
      list.style.flexWrap = 'wrap';
      list.style.gap = gap;
    }
  }

  // Klick auf Bild-Item öffnet Lightbox
  document.addEventListener('click', function(e) {
    const item = e.target.closest('.product__media-item');
    if (!item) return;
    if (item.dataset.mediaType !== 'image') return;
    if (item.style.display === 'none') return;

    const mg = document.querySelector('media-gallery');
    if (!mg || !mg.lightbox) return;

    const index = window.ypVisibleItems.indexOf(item);
    if (index === -1) return;

    e.preventDefault();
    e.stopPropagation();
    mg.lightbox.loadAndOpen(index);
  }, true);

  function reinitPhotoSwipe(visibleItems) {
    window.ypVisibleItems = visibleItems;
    const mg = document.querySelector('media-gallery');
    if (mg && mg.enableImageZoom && typeof mg.initImageZoom === 'function') {
      mg.initImageZoom(visibleItems);
    }
  }

  function filterGallery() {
    const activeVariant = getActiveVariantName();

    // Einzelvarianten-Produkt: keine Radio-Buttons vorhanden
    // Alle Bilder anzeigen und Grid-Pattern direkt anwenden
    if (!activeVariant) {
      const items = getItems();
      if (items.length === 0) return;
      const allItems = Array.from(items);
      allItems.forEach(item => { item.style.display = ''; });
      applyGridPattern(allItems);
      reinitPhotoSwipe(allItems);
      return;
    }

    const allVariants = getAllVariantNames();
    const otherVariants = allVariants.filter(v => v !== activeVariant);

    const items = getItems();
    if (items.length === 0) return;

    const visibleItems = [];
    let anyVisible = false;

    items.forEach((item) => {
      const img = item.querySelector('img');
      const src = img ? (img.src || img.dataset.src || '').toLowerCase() : '';

      // Für Video-Slides: alt-Text des Vorschaubilds prüfen
      const videoEl = item.querySelector('video-element, deferred-media');
      let checkSrc = src;
      if (videoEl) {
        const videoImg = videoEl.querySelector('img');
        const videoAlt = videoImg ? (videoImg.alt || '').toLowerCase() : '';
        const videoSource = videoEl.querySelector('source');
        const videoSrcUrl = videoSource ? videoSource.src.toLowerCase() : '';
        const tmpl = videoEl.querySelector('template');
        const tmplContent = tmpl ? tmpl.innerHTML.toLowerCase() : '';
        checkSrc = src + ' ' + videoAlt + ' ' + videoSrcUrl + ' ' + tmplContent;
      }

const belongsToOther = otherVariants.some(v =>
  checkSrc.includes(v) || checkSrc.includes(v.replace(/-/g, '_'))
);
const isMini = checkSrc.includes('_mini') || checkSrc.includes('-mini');

      item.style.width = '';
      item.style.flex = '';
      item.style.maxWidth = '';

      if (belongsToOther || isMini) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
        visibleItems.push(item);
        anyVisible = true;
      }
    });

    if (!anyVisible) {
      items.forEach(item => {
        item.style.display = '';
        visibleItems.push(item);
      });
    }

    applyGridPattern(visibleItems);
    reinitPhotoSwipe(visibleItems);

    // Video-Items: Zoom-Button + Klick öffnet native Lightbox
    visibleItems.forEach(function(item, idx) {
      if (item.dataset.mediaType !== 'video') return;

      function openVideoInPswp() {
        var mg = document.querySelector('media-gallery');
        var lb = mg && mg.lightbox;
        if (!lb) return;
        lb.loadAndOpen(idx, lb.options.dataSource);

      }

      // Zoom-Button (identisch wie bei Bildern)
      if (!item.querySelector('.yp-video-zoom-btn')) {
        var zoomBtn = document.createElement('button');
        zoomBtn.className = 'product__media-zoom btn--inherit yp-video-zoom-btn';
        zoomBtn.type = 'button';
        zoomBtn.setAttribute('aria-haspopup', 'dialog');
        zoomBtn.innerHTML = '<span class="visually-hidden">\u00d6ffnen Sie das Video im Modalmodus</span>';
        zoomBtn.addEventListener('click', function(e) { e.stopPropagation(); openVideoInPswp(); });
        item.appendChild(zoomBtn);
      }

      // Klick auf Video öffnet Lightbox
      var ve = item.querySelector('video-element');
      if (ve && !ve.__ypLightboxClick) {
        ve.__ypLightboxClick = true;
        ve.addEventListener('click', function(e) { e.stopPropagation(); openVideoInPswp(); });
        ve.style.cursor = 'zoom-in';
      }
    });
  }

  function waitForGallery(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 50) return;

    const mg = document.querySelector('media-gallery');
    const item = document.querySelector('.product__media-list .product__media-item');

    if (mg && item) {
      setTimeout(callback, 500);
    } else {
      setTimeout(function() {
        waitForGallery(callback, attempts + 1);
      }, 100);
    }
  }

  // Globaler Patch: Video-Abspielen + Format + Swipe in der Lightbox
  function patchLightboxForVideo() {
    var mg = document.querySelector('media-gallery');
    var lb = mg && mg.lightbox;
    if (!lb || lb.__ypVideoPatch) return;
    lb.__ypVideoPatch = true;

    var origLoad = lb.loadAndOpen.bind(lb);
    lb.loadAndOpen = function(index, dataSource) {
      // Vor dem Öffnen: deferred-media in allen Video-Items vorladen
      // damit PhotoSwipe das video-element sofort rendern kann
      document.querySelectorAll('.product__media-item video-element deferred-media, .product__media-item deferred-media').forEach(function(dm) {
        if (!dm.getAttribute('loaded')) {
          if (typeof dm.loadContent === 'function') {
            dm.loadContent();
          } else {
            var tmpl = dm.querySelector('template');
            if (tmpl && !dm.querySelector('video-element')) {
              dm.appendChild(tmpl.content.cloneNode(true));
              dm.setAttribute('loaded', 'true');
            }
          }
        }
      });
      var result = origLoad(index, dataSource);

      // Warte auf pswp und video-element — beide mit rAF, kein setInterval
      var outerN = 0;
      function waitForPswp() {
        var pswp = window.pswp;
        if (!pswp) {
          if (++outerN < 50) requestAnimationFrame(waitForPswp);
          return;
        }

        // Gibt das video-element im pswp__item mit pswp__content zurück.
        // Das Video ist NICHT immer in aria-hidden="false" — PhotoSwipe
        // rendert das Video-Item als Nachbar-Slide vor (aria-hidden="true").
        // Wir suchen das Item das tatsächlich einen pswp__content hat.
        function getActiveVideoEl() {
          // Item mit pswp__content finden (nur Video-Slides haben das)
          var items = document.querySelectorAll('.pswp__item');
          for (var i = 0; i < items.length; i++) {
            var pc = items[i].querySelector('.pswp__content');
            if (pc) {
              var ve = pc.querySelector('video-element');
              if (ve) return ve;
            }
          }
          return null;
        }

        function playVideo() {
          var ve = getActiveVideoEl();
          if (!ve) return;
          if (!ve.getAttribute('loaded') && typeof ve.initializePlayer === 'function') {
            ve.initializePlayer();
          }
          var v = ve.querySelector('video');
          if (!v) return;

          // pauseAllMedia von theme.js abfangen:
          // Shopify pausiert alle Medien beim Scrollen/Slide-Wechsel
          // Wir überschreiben pause() damit das Video sofort wieder abgespielt wird
          if (!v.__ypPausePatch) {
            v.__ypPausePatch = true;
            var origPause = v.pause.bind(v);
            v.pause = function() {
              origPause();
              setTimeout(function() {
                if (v.paused && v.__ypShouldPlay) {
                  v.play().catch(function(){});
                }
              }, 50);
            };
          }
          v.__ypShouldPlay = true;
          if (v.paused) v.play().catch(function(){});
        }

        // Format-Fix: Video exakt wie Bilder in der Lightbox rendern
        // Bilder: zoom-wrap = translate3d((vpW-size)/2, 0, 0), pswp__img = size x size
        // Video: dasselbe — zoom-wrap zentrieren, pswp__content = size x size, top/left 0
function fixVideoLayout() {
          var ve = getActiveVideoEl();
          if (!ve) return;
          var pc = ve.closest('.pswp__content');
          if (!pc) return;
          var zw = pc.closest('.pswp__zoom-wrap');
          if (!zw) return;

          var vpW = window.innerWidth;
          var vpH = window.innerHeight;

          // Video-Dimensionen für Seitenverhältnis
          var vid = ve.querySelector('video');
          var vw = vid && vid.videoWidth  ? vid.videoWidth  : 0;
          var vh = vid && vid.videoHeight ? vid.videoHeight : 0;

          // Größe identisch zu pswp__img bei Bildern: Math.min(vpW, vpH)
          var size = Math.min(vpW, vpH);
          if (vw > 0 && vh > 0) {
            // Seitenverhältnis berücksichtigen
            var scale = Math.min(vpW / vw, vpH / vh);
            size = Math.min(Math.round(vw * scale), Math.round(vh * scale));
          }

          // zoom-wrap: translate3d identisch zu Bildern — (vpW-size)/2
          var tx = Math.round((vpW - size) / 2);
          var ty = Math.round((vpH - size) / 2);
          zw.style.transform = 'translate3d('+tx+'px, '+ty+'px, 0px) scale3d(1, 1, 1)';
          zw.style.transformOrigin = '0px 0px';

          // pswp__content: size x size, top/left 0 — identisch zu pswp__img bei Bildern
          pc.style.setProperty('width', size+'px', 'important');
          pc.style.setProperty('height', size+'px', 'important');
          pc.style.setProperty('top', '0px', 'important');
          pc.style.setProperty('left', '0px', 'important');
          pc.style.setProperty('position', 'absolute', 'important');
          pc.style.setProperty('overflow', 'hidden', 'important');
          pc.querySelectorAll('.pswp__item--video, video-element, video').forEach(function(el) {
            el.style.setProperty('width', size+'px', 'important');
            el.style.setProperty('height', size+'px', 'important');
            el.style.setProperty('max-height', 'none', 'important');
            el.style.setProperty('object-fit', 'cover', 'important');
            el.style.setProperty('position', 'relative', 'important');
            el.style.setProperty('display', 'block', 'important');
          });
          if (vid && !vid.videoWidth) {
            vid.addEventListener('loadedmetadata', function() { fixVideoLayout(); }, { once: true });
          }
          pc.classList.add('yp-video-ready');
          var sw = pswp.scrollWrap;
          if (sw && !sw.querySelector('.yp-swipe-img')) {
            pc.querySelectorAll('*').forEach(function(el) {
              el.style.setProperty('pointer-events', 'none', 'important');
            });
            var swW = sw.offsetWidth || window.innerWidth;
            var swH = sw.offsetHeight || window.innerHeight;
            var size = Math.min(swW, swH);
            var left = Math.round((swW - size) / 2);
            var top = Math.round((swH - size) / 2);
            var img = document.createElement('img');
            img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
            img.className = 'pswp__img yp-swipe-img';
            img.style.cssText = 'position:absolute;top:'+top+'px;left:'+left+'px;width:'+size+'px;height:'+size+'px;z-index:9999;opacity:0;display:block;pointer-events:auto;cursor:grab;';
            sw.appendChild(img);
          }
        }
        // iOS Safari: Touch-Swipe auf Video-Slide via moveIndexBy
        // Desktop: PhotoSwipe handled Maus-Swipe selbst
        function patchVideoTouch() {
          if (pswp.__ypSwipePatch) return;
          pswp.__ypSwipePatch = true;

          var pswpEl = pswp.element;
          var startX = 0, startY = 0, tracking = false, lastSwipe = 0;
          var THRESHOLD = 3, COOLDOWN = 800;

          function isVideoSlideActive() {
            var items = document.querySelectorAll('.pswp__item');
            for (var i = 0; i < items.length; i++) {
              if (items[i].getAttribute('aria-hidden') === 'false') {
                return !!items[i].querySelector('.pswp__content');
              }
            }
            return false;
          }

          pswpEl.addEventListener('touchstart', function(e) {
            var t = e.touches[0];
            startX = t.clientX; startY = t.clientY; tracking = true;
          }, { capture: true, passive: true });

          pswpEl.addEventListener('touchend', function(e) {
            if (!tracking) return;
            tracking = false;
            if (!isVideoSlideActive()) return;
            var t = e.changedTouches[0];
            var dx = t.clientX - startX;
            var dy = t.clientY - startY;
            if (Math.abs(dx) < THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
            var now = Date.now();
            if (now - lastSwipe < COOLDOWN) return;
            lastSwipe = now;
            if (pswp.mainScroll.canBeSwiped()) {
              pswp.mainScroll.moveIndexBy(dx < 0 ? 1 : -1, true);
            }
          }, { capture: true, passive: true });

          pswpEl.addEventListener('touchcancel', function(e) {
            tracking = false;
          }, { capture: true, passive: true });

          // Desktop Mouse Handler
          var mStartX = 0, mStartY = 0, mTracking = false;

          document.addEventListener('pointerdown', function(e) {
            if (e.pointerType !== 'mouse') return;
            if (!e.target.closest('.pswp')) return;
            mStartX = e.clientX; mStartY = e.clientY; mTracking = true;
          }, { capture: true, passive: true });

          document.addEventListener('pointermove', function(e) {
            if (!mTracking || e.pointerType !== 'mouse') return;
            var dx = e.clientX - mStartX;
            var dy = e.clientY - mStartY;
            if (Math.abs(dx) >= THRESHOLD && Math.abs(dy) < Math.abs(dx)) {
              mTracking = false;
              // isVideoSlideActive prüfen NACH dem Threshold — nicht vorher abbrechen
              if (!isVideoSlideActive()) return;
              var now = Date.now();
              if (now - lastSwipe < 400) return;
              lastSwipe = now;
              if (pswp.mainScroll.canBeSwiped()) {
                pswp.mainScroll.moveIndexBy(dx < 0 ? 1 : -1, true);
              }
            }
          }, { capture: true, passive: true });

          document.addEventListener('pointerup', function(e) {
            if (e.pointerType !== 'mouse') return;
            if (mTracking) {
              // pointermove hat nicht ausgelöst — bei pointerup nochmal messen
              var dx = e.clientX - mStartX;
              var dy = e.clientY - mStartY;
              mTracking = false;
              if (Math.abs(dx) >= THRESHOLD && Math.abs(dy) < Math.abs(dx) && isVideoSlideActive()) {
                var now = Date.now();
                if (now - lastSwipe < 400) return;
                lastSwipe = now;
                if (pswp.mainScroll.canBeSwiped()) {
                  pswp.mainScroll.moveIndexBy(dx < 0 ? 1 : -1, true);
                }
              }
            }
          }, { capture: true, passive: true });
        }

        // rAF-Polling bis video-element im aktiven Slide im DOM ist
        // Falls deferred-media vorhanden aber noch nicht initialisiert: loadContent() triggern
        function waitForVideoEl(cb) {
          var n = 0;
          function check() {
            // Im Item mit pswp__content suchen (Video-Slide, nicht notwendig aria-hidden=false)
            var items = document.querySelectorAll('.pswp__item');
            var videoItem = null;
            for (var i = 0; i < items.length; i++) {
              if (items[i].querySelector('.pswp__content')) { videoItem = items[i]; break; }
            }
            // deferred-media initialisieren falls nötig
            var dm = videoItem && videoItem.querySelector('deferred-media');
            if (dm && !dm.getAttribute('loaded')) {
              if (typeof dm.loadContent === 'function') {
                dm.loadContent();
              } else {
                var tmpl = dm.querySelector('template');
                if (tmpl) {
                  dm.appendChild(tmpl.content.cloneNode(true));
                  dm.setAttribute('loaded', 'true');
                }
              }
            }
            var ve = videoItem && videoItem.querySelector('video-element');
            if (ve) { cb(); return; }
            if (++n < 60) requestAnimationFrame(n < 10 ? check : function() { setTimeout(check, 50); });
          }
          requestAnimationFrame(check);
        }

        // MutationObserver: korrigiert sofort wenn PhotoSwipe zoom-wrap oder pswp__content ändert
        var ypFixObserver = null;
        function startFixObserver() {
          if (ypFixObserver) { ypFixObserver.disconnect(); ypFixObserver = null; }
          var zw = document.querySelector('.pswp__item[aria-hidden="false"] .pswp__zoom-wrap');
          var pc = document.querySelector('.pswp__item[aria-hidden="false"] .pswp__content');
          if (!zw && !pc) return;
          var busy = false;
          ypFixObserver = new MutationObserver(function() {
            if (busy) return;
            busy = true;
            requestAnimationFrame(function() { fixVideoLayout(); busy = false; });
          });
          if (zw) ypFixObserver.observe(zw, { attributes: true, attributeFilter: ['style'] });
          if (pc) ypFixObserver.observe(pc, { attributes: true, attributeFilter: ['style'] });
        }

        function runFix() {
          fixVideoLayout();
          playVideo();
          patchVideoTouch();
          startFixObserver();
        }

        // Globaler MutationObserver auf pswp.element:
        // Reagiert IMMER wenn video-element in pswp erscheint —
        // egal ob erstes Öffnen, zweites Öffnen, Recycling oder Varianten-Wechsel
        var globalVideoObserver = new MutationObserver(function(mutations) {
          for (var m = 0; m < mutations.length; m++) {
            var added = mutations[m].addedNodes;
            for (var n = 0; n < added.length; n++) {
              var node = added[n];
              if (!node.querySelector) continue;
              // Prüfen ob video-element im hinzugefügten Node
              var ve = node.querySelector('video-element') ||
                       (node.classList && node.classList.contains('pswp__content') && node.querySelector('video-element'));
              if (ve) {
                // Kurz warten bis DOM stabil ist, dann Fix anwenden
                setTimeout(runFix, 50);
                return;
              }
            }
          }
        });
        globalVideoObserver.observe(pswp.element, { childList: true, subtree: true });

        // Erster Durchlauf: video-element könnte bereits im DOM sein
        waitForVideoEl(runFix);

        pswp.on('change', function() {
          if (ypFixObserver) { ypFixObserver.disconnect(); ypFixObserver = null; }
          // GIF bleibt immer aktiv — liegt nur über Bildbereich, nicht über Buttons
          // zoom-wrap SOFORT korrigieren — PhotoSwipe setzt es auf 0,0,0 zurück
          var ve = getActiveVideoEl();
          if (ve) {
            var pc = ve.closest('.pswp__content');
            var zw = pc && pc.closest('.pswp__zoom-wrap');
            if (zw) {
              var vpW = window.innerWidth;
              var vpH = window.innerHeight;
              var size = Math.min(vpW, vpH);
              var vid = ve.querySelector('video');
              var vw = vid && vid.videoWidth ? vid.videoWidth : 0;
              var vh = vid && vid.videoHeight ? vid.videoHeight : 0;
              if (vw > 0 && vh > 0) {
                var scale = Math.min(vpW / vw, vpH / vh);
                size = Math.min(Math.round(vw * scale), Math.round(vh * scale));
              }
              var tx = Math.round((vpW - size) / 2);
              var ty = Math.round((vpH - size) / 2);
              zw.style.transform = 'translate3d('+tx+'px,'+ty+'px,0px) scale3d(1,1,1)';
              zw.style.transformOrigin = '0px 0px';
            }
            playVideo();
          }
        });

        pswp.on('destroy', function() {
          globalVideoObserver.disconnect();
          if (ypFixObserver) { ypFixObserver.disconnect(); ypFixObserver = null; }
          setTimeout(function() {
            document.querySelectorAll('.product__media-item video-element').forEach(function(gve) {
              var gv = gve.querySelector('video');
              if (gv && gv.paused) gv.play().catch(function(){});
            });
          }, 300);
        });
      }
      requestAnimationFrame(waitForPswp);
      return result;
    };
  }

  function init() {
    waitForGallery(function() {
      filterGallery();
      patchLightboxForVideo();

      function repatchLightbox() {
        // Lightbox-Flag zurücksetzen damit Patch nochmal läuft
        // (Shopify erstellt beim Variantenwechsel neue Lightbox-Instanz)
        var mg2 = document.querySelector('media-gallery');
        if (mg2 && mg2.lightbox) {
          mg2.lightbox.__ypVideoPatch = false;
        }
        filterGallery();
        patchLightboxForVideo();
      }

      document.addEventListener('change', function(e) {
        if (e.target.type === 'radio') {
          setTimeout(repatchLightbox, 300);
        }
      });

      document.addEventListener('variant:changed', function() {
        setTimeout(repatchLightbox, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();